import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [];

    static outlets = [];

    static values = {
        from: Number
    }

    connect() {
    }

    search() {
        let id = this.element.querySelector('[type="hidden"]').value;

        if (id) {
            window.location.href = '?id=' + id;
        }
    }

    path() {
        let fromId = this.fromValue;
        let toId = this.element.querySelector('[type="hidden"]').value;

        if (fromId && toId) {
            window.location.href = '?id=' + toId + ',' + fromId;
        }
    }
}
    